import { Button, ButtonVariant, Modal, ModalSize, Text } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import { Row } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

interface IDeleteConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmModal = ({ isOpen, onConfirm, onCancel }: IDeleteConfirmModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal size={ModalSize.SMALL} open={isOpen} onOpenChange={onCancel} title={t("common:modal.generateAvatar.deleteImage.title")}>
      <div className="flex flex-col gap-4">
        <Text className="mb-4">
          <Trans i18nKey="common:modal.generateAvatar.deleteImage.description" />
        </Text>
        <Row justify="end" className="gap-2">
          <Button variant={ButtonVariant.OUTLINED} onClick={onCancel}>
            <Trans i18nKey="common:cancel" />
          </Button>
          <Button variant={ButtonVariant.CONTAINED} onClick={onConfirm}>
            <Trans i18nKey="common:delete" />
          </Button>
        </Row>
      </div>
    </Modal>
  );
};
